const variants = {
  primary:
    'text-white border-0',
  secondary:
    'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50',
  danger:
    'bg-white text-[#b42318] border border-[#f0c7c2] hover:bg-[#fdf2f0]',
  ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 border border-transparent',
  link: 'bg-transparent text-[#1a3366] hover:underline border-0 shadow-none p-0',
}

const sizes = {
  xs: 'px-2 py-1 text-xs rounded-md',
  sm: 'px-2.5 py-1 text-sm rounded-md',
  md: 'px-4 py-2 text-sm rounded-lg',
  lg: 'px-5 py-2.5 text-sm rounded-lg',
}

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 font-semibold transition-all disabled:opacity-50 disabled:pointer-events-none ${variants[variant]} ${sizes[size]} ${className}`}
      style={variant === "primary" ? { background: "#1a3366" } : undefined}
      {...props}
    >
      {children}
    </button>
  )
}
